import React, { FC } from "react";
import styles from "./Wizard.module.scss";

/** Container for active page displayed in Wizard component */
export const WizardPageContainer: FC = ({ children }) => {
  return <div className={styles.pageContainer}>{children}</div>;
};
